import React, { useMemo } from 'react'

import Chart from './ImpliedRatingChart.d3'
import ChartWrapper from '../ChartWrapper'

const ImpliedRatingChart = ({
  data,
  inModal,
  chartId,
  relations,
  setSelection = () => {},
  left,
  right,
}) => {
  const updateProps = useMemo(
    () => ({
      data,
    }),
    [data],
  )

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{
        data,
        relations,
        setSelection,
        inModal,
        chartId,
      }}
      updateProps={updateProps}
      margin={{ BOTTOM: 20, LEFT: left, RIGHT: right }}
    />
  )
}

export default ImpliedRatingChart
